// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__2urtt","footer":"Footer_footer__1Xkx-"};